export default __webpack_public_path__ + "static/media/ec2Closed.e4de2dfb.jpg";